import {initWebComponent} from "@/helpers/web-component-helper";
import {activateUserSessionByID, getUserSessionByID, updateSession} from "@/helpers/user-session-helper";
import {showNotification} from "@/helpers/notification-helper";

export class BookmarkUserSessionShareButtonComponent extends HTMLElement {
    constructor(){
        super();

        const token = this.getAttribute('data-token')
        const template = document.createElement('template');

        template.innerHTML = `<button class="btn btn-sm borderless icon-btn popper-header">
              <i class="fa fa-share-alt"></i>
              <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                 Bookmark delen met anderen
                <div class="arrow" data-popper-arrow=""></div>
              </div>
              <input type="text" value="` + window.kaartViewerUrl + '&token=' + token + `" class="d-none">
            </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
          //   let copyText = this.querySelector("input");
          //   copyText.classList.remove('d-none')
          //   copyText.select();
          //   document.execCommand("copy");
          //   copyText.classList.add('d-none')
          //
          // showNotification('De link is gekopieërd naar het clipboard. Je kan het plakken met ctrl+v of rechtermuisknop.')
            showNotification('Dit is nog niet mogelijk in deze versie', '', 'warning')
        })
    }
}
